// extracted by mini-css-extract-plugin
module.exports = {"chatBox":"Chat_chatBox__12tcS"};